
import scriptMarkerClusterer from 'js-marker-clusterer'


function gmapsLoad(apiKey = '', callback = () => {}) {
	window.gmapsFns = window.gmapsFns || []
	if (window.gmapsLoaded) return callback()
	if (!window.gmapsLoaded) window.gmapsFns.push(callback)
	if (!window.onGmapsLoad) {
		window.onGmapsLoad = () => {
			window.gmapsLoaded = true
			window.gmapsFns.map(fn => fn())
		}
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=onGmapsLoad`
		document.body.appendChild(script)
	}
}


function createMap(el, pins, options) {

	const defaultSettings = {
		zoom: 15,
		panControl: false, // left right up down circle
		scrollwheel: false, // scrollwheel zoom
		zoomControl: true, // + - controls
		streetViewControl: false,
		mapTypeControl: false,
		overviewMapControl: false,
		mapPin: false,
		clusterImages: false,
		center: new google.maps.LatLng(0, 0),
	}

	const settings = { ...defaultSettings, ...options }

	// single pin, convert to array
	if (pins && pins.lat && pins.lng) pins = [pins]	

	// default center on first pin
	if (pins.length)
		settings.center = new google.maps.LatLng(pins[0].lat, pins[0].lng)

	const gmap = new google.maps.Map(el, settings)
    const markers = []

    pins.forEach(pin => {
    	if (!pin.lat || !pin.lng) return
		let marker = new google.maps.Marker({
		    position : new google.maps.LatLng(pin.lat, pin.lng),
		    map: gmap,
		    name : (pin.name) ? pin.name : null,
		    icon: (settings.mapPin) ? settings.mapPin : null
		})
		markers.push(marker)
    })

    const bounds = new google.maps.LatLngBounds()
    markers.forEach(marker => bounds.extend(marker.getPosition()))
    markers.length && gmap.fitBounds(bounds)

    let clusterOptions = { imagePath: settings.clusterImages }
    let markerCluster = new MarkerClusterer(gmap, markers, clusterOptions)
}


const svg = `<?xml version="1.0" encoding="UTF-8"?>
	<svg width="38px" height="66px" viewBox="0 0 38 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
	    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	        <g id="Group">
	            <path d="M19,0 C8.50591447,0 0,8.53657895 0,19.0792105 C0,29.6218421 8.50591447,41.5626316 19,66 C29.4940855,41.5626316 38,29.6218421 38,19.0792105 C38,8.53657895 29.4940855,0 19,0" id="Fill-1" fill="#E3051F"></path>
	            <circle id="Oval" fill="#FFFFFF" cx="19" cy="19" r="10"></circle>
	        </g>
	    </g>
	</svg>`


export function map(mapEl, { apiKey = '', clusterImages = '' }) {

	if (!mapEl) return
	const pins = JSON.parse(mapEl.getAttribute('data-locations') || '[]')
	const mapOptions = {
		clusterImages: clusterImages,
		mapPin: {
			url: `data:image/svg+xml;base64,${btoa(svg)}`
		}
	}
	gmapsLoad(apiKey, () => createMap(mapEl, pins, mapOptions))
}